import React from 'react'
import { Grid, Segment } from 'semantic-ui-react'
import StatsDashboardDropdowns from './Dashboard/components/StatsDashboardDropdowns'
import { DetailHeader } from './DetailHeader'

interface IStatsLayout {
  title: string
  testId: string
  backButton?: boolean
  showDateFilters?: boolean
}

const StatsLayout: React.FC<IStatsLayout> = ({ children, title, testId, backButton, showDateFilters }) => {
  return (
    <Segment data-testid={testId}>
      <Grid>
        <DetailHeader title={title} backButton={backButton} />
        <StatsDashboardDropdowns showDateFilters={showDateFilters} />
        {children}
      </Grid>
    </Segment>
  )
}

export default StatsLayout
